module.exports = __webpack_public_path__ + "static/nest-tourism-innovation-center-portugallogo-8a2bfb7dcff2e6f5180aa1e44601909e.gif";